import { Box, Button, Typography } from "@mui/material";
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom"

import logo from '../assets/images/logo.svg'
import thaiID from '../assets/icons/thaiID.svg'

import qrcode from '../assets/images/thaiDQRcode.png'
import Loader from "../components/Loader";

import * as apiAuth from '../services/ApiAuthentication'
import { notifyError, notifyInfo } from "../components/NotifyToast";

export default function GuideService() {

    const [loading, setLoading] = useState(false)

    const clickQRcodeThaiD = async () => {

        setLoading(true)
        let res = await apiAuth.getQrCode()
        setLoading(false)
        
        if (res) {
            if (res['data']['code'] === 200) {
                window.open(res['data']['data']['sso_thaid_url'], '_self')
            } else {
                notifyInfo(res['data']['message'])
            }
        } else {
            notifyError('ไม่ตอบสนอง')
        }
    }


    return (
        <div className='bg__health__atm'>
            <Loader loading={loading} />
            <Box sx={{
                height: '100vh',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                alignSelf: 'center',
                fontSize: '16px',
                '@media (orientation: portrait)': {
                    fontSize: '4vw',
                }
            }}>
                <Box sx={{
                    height: 'auto',
                    backgroundColor: '#FFFFFF',
                    border: '1px solid #E1E3E9',
                    boxShadow: '0 0 5px #E1E3E9',
                    borderRadius: '1.25em',
                    padding: '2.5em',
                    margin: '1.25em',
                    display: 'grid',
                    justifyItems: 'center',
                    alignSelf: 'center',
                    gridGap: '1.25em',
                    '@media (orientation: portrait)': {
                        padding: '1.5em 1em',
                        gridGap: '1.25em',
                    }
                }}>

                    <Box sx={{
                        display: 'flex',
                        '@media (orientation: portrait)': {
                            display: 'grid'
                        }
                    }}>
                        <Box sx={{ display: 'grid', alignContent: 'center', gap:2 }}>

                            <Box sx={{
                                display: 'flex',
                                justifyContent: 'center',
                            }}>
                                <img style={{ width: '50%' }} src={logo} alt='omnix_health_atm_logo'/>
                            </Box>

                            <Box sx={{ display: 'grid', gridGap: '0.625em' }}>
                                <Typography sx={{
                                    fontSize: '1.125em',
                                    fontWeight: 700,
                                    color: '#082C91',
                                    display: 'grid',
                                    justifyItems: 'center',
                                    '@media (orientation: portrait)': {
                                        mt:'0.5em',
                                        fontSize: '1em',
                                    }
                                }}>กดปุ่ม</Typography>
                                <Box sx={{
                                    display: 'flex',
                                    justifyContent: 'center'
                                }}>
                                    <Button
                                        variant="contained"
                                        color="c_yellow"
                                        sx={{
                                            borderRadius: '0.625em',
                                            display: 'flex',
                                            gridGap: '1em',
                                            fontSize: '1.125em',
                                            '@media (orientation: portrait)': {
                                                fontSize: '1em',
                                            }
                                        }}
                                        onClick={() => { clickQRcodeThaiD() }}
                                    >
                                        <img className="imgIcon" alt="ThaID QR" src={thaiID} />
                                        <Box>สแกน QR Code ด้วยแอป ThaiD</Box>
                                    </Button>
                                </Box>
                                <Box sx={{
                                    fontSize: '1.125em',
                                    fontWeight: 600,
                                    color: '#082C91',
                                    display: 'grid',
                                    justifyItems: 'center',
                                    '@media (orientation: portrait)': {
                                        fontSize: '1em',
                                    }
                                }}>
                                    <div>เพื่อเข้ารับบริการ เอทีเอ็มสุขภาพ</div>
                                </Box>
                            </Box>
                        </Box>

                        <Box sx={{
                            borderLeft: '2px solid #E1E3E9',
                            margin: '0 2em',
                            '@media (orientation: portrait)': {
                                borderTop: '2px solid #E1E3E9',
                                margin: '1.5em 0',
                            }
                        }}></Box>

                        <Box sx={{ display: 'grid', gridGap: '0.5em' }}>
                            <Box sx={{
                                fontSize: '1.125em',
                                fontWeight: 600,
                                color: '#082C91',
                                display: 'grid',
                                justifyItems: 'center',
                                alignItems: 'end',
                                '@media (orientation: portrait)': {
                                    fontSize: '1em'
                                }
                            }}>
                                <div>หากยังไม่มี ThaiD สแกน QR Code นี้</div>
                            </Box>
                            <Box sx={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                            }}>
                                <img src={qrcode} style={{ width:'100%',  maxWidth: '9em', maxHeight: '9em' }} alt='ThaID App QR' />
                            </Box>
                            <Box sx={{
                                fontSize: '1.125em',
                                fontWeight: 600,
                                color: '#082C91',
                                display: 'grid',
                                justifyItems: 'center',
                                alignItems: 'start',
                                '@media (orientation: portrait)': {
                                    fontSize: '1em'
                                }
                            }}>
                                <div>เพื่อดาวน์โหลดแอป ThaiD</div>
                            </Box>
                        </Box>
                    </Box>
                </Box>
            </Box>
        </div>
    )
}